import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { AdminGate, AdminShell } from "./AdminGate";
import { Loader2, History } from "lucide-react";

const ENTIDADES = ["", "settings", "pricing", "motorista", "termo", "erro_upload"];
const ENTIDADE_LABEL = { "": "Todas", settings: "Configurações", pricing: "Preços", motorista: "Motoristas", termo: "Termos", erro_upload: "Erros de upload" };

function Logs({ user }) {
  const [logs, setLogs] = useState(null);
  const [entidade, setEntidade] = useState("");

  useEffect(() => {
    setLogs(null);
    api.get(`/admin/logs${entidade ? `?entidade=${entidade}` : ""}`)
      .then((r) => setLogs(r.data.logs))
      .catch(() => setLogs([]));
  }, [entidade]);

  return (
    <AdminShell user={user} title="Histórico / Logs">
      <div className="px-4 mt-4 space-y-3" data-testid="admin-logs-page">
        <div className="flex gap-1.5 flex-wrap" data-testid="logs-filtros">
          {ENTIDADES.map((e) => (
            <button key={e} data-testid={`logs-filtro-${e || "todas"}`} onClick={() => setEntidade(e)}
              className={`px-3 py-1.5 rounded-full text-[11px] font-bold ${entidade === e ? "bg-navy text-[#F5B301]" : "bg-white text-slate-500 border border-slate-200"}`}>
              {ENTIDADE_LABEL[e]}
            </button>
          ))}
        </div>

        {logs === null && <div className="flex justify-center py-14"><Loader2 className="w-8 h-8 animate-spin text-[#F5B301]" /></div>}
        {logs !== null && logs.length === 0 && (
          <p className="text-center text-sm text-slate-400 py-14" data-testid="logs-empty">Nenhum registro ainda.</p>
        )}
        {(logs || []).map((l) => (
          <div key={l.id} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-3.5" data-testid={`log-${l.id}`}>
            <div className="flex items-start gap-2">
              <History className="w-4 h-4 text-[#F5B301] mt-0.5 shrink-0" />
              <div className="flex-1">
                <p className="text-xs font-semibold text-navy leading-snug">{l.detalhe || l.acao}</p>
                {(l.valor_anterior !== null && l.valor_anterior !== undefined) && (
                  <p className="text-[11px] text-slate-500 mt-0.5">
                    Antes: <span className="font-mono">{JSON.stringify(l.valor_anterior)}</span> → Depois: <span className="font-mono">{JSON.stringify(l.valor_novo)}</span>
                  </p>
                )}
                <p className="text-[10px] text-slate-400 mt-1">
                  {l.admin_nome || l.admin_email} · {new Date(l.em).toLocaleString("pt-BR")}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </AdminShell>
  );
}

export default function AdminLogs() {
  return <AdminGate>{(user) => <Logs user={user} />}</AdminGate>;
}
